import CryptoJS from 'crypto-js/crypto-js.js';
import iStoreUtils from '@/scripts/istore-utils.js';

const iStoreLocalData = {
  key: {
    version: 'VERSION',
    TOKEN: 'TOKEN',
    isAuthenticated: 'isAuthenticated',
  },
  expiryTime: 60000 * 60 * 1, // 1 hour
  setItem(key, data) {
    try {
      window.localStorage.setItem(key, iStoreUtils.encode(data));
    } catch (error) {
      console.error(error)
    }
  },
  getItem(key, defaultValue) {
    try {
      let temp = window.localStorage.getItem(key);
      if (temp) {
        return iStoreUtils.decode(temp);
      }
    } catch (error) {
      console.error(error)
    }
    if (defaultValue) {
      return defaultValue;
    }
  },
  removeItem(key) {
    console.debug('removeItem [%s]', key);
    try {
      return window.localStorage.removeItem(key);
    } catch (error) {
      console.error(error)
    }
  },
  setSessionItem(key, data) {
    try {
      window.sessionStorage.setItem(key, iStoreUtils.encode(data));
    } catch (error) {
      console.error(error)
    }
  },
  getSessionItem(key, defaultValue) {
    try {
      let temp = window.sessionStorage.getItem(key);
      if (temp) {
        return iStoreUtils.decode(temp);
      }
    } catch (error) {
      console.error(error)
    }
    if (defaultValue) {
      return defaultValue;
    }
  },
  removeSessionItem(key) {
    console.debug('removeItem [%s]', key);
    try {
      return window.sessionStorage.removeItem(key);
    } catch (error) {
      console.error(error)
    }
  },

  getToken() {
    return this.getSessionItem(this.key.TOKEN, null)
  },
  setToken(token) {
    this.setSessionItem(this.key.TOKEN, token)
  },
  setAuthenticated(isAuth) {
    if (isAuth) {
      this.setSessionItem(this.key.isAuthenticated, 'iStoreUI-Y')
    } else {
      this.removeSessionItem(this.key.isAuthenticated)
    }
  },
  isAuthenticated() {
    return this.getSessionItem(this.key.isAuthenticated, 'N') === 'iStoreUI-Y'
  },
  /** 印出使用量 */
  calcLocalStorageSize
    () {
    let total = 0,
      size, key;
    for (key of Object.keys(localStorage)) {
      size = ((localStorage[key].length + key.length) * 2);
      total += size;
      console.log(key.substr(0, 50) + ' = ' + (size / 1024).toFixed(2) + ' KB')
    }
    for (key of Object.keys(sessionStorage)) {
      size = ((sessionStorage[key].length + key.length) * 2);
      total += size;
      console.log(key.substr(0, 50) + ' = ' + (size / 1024).toFixed(2) + ' KB')
    }
    console.debug('Total = ' + (total / 1024).toFixed(2) + ' KB');
  },
  printAllItems() {
    let keys = Object.keys(this.key);
    keys = keys.sort();
    for (let k of keys) {
      let data = this.getItem(this.key[k]);
      if (data) {
        console.log('[' + k + '] = ' + data);
      } else {
        data = this.getSessionItem(this.key[k]);
        if (data) {
          console.log('[' + k + '] = ' + data);
        }
      }
    }
  },
  removeAll() {
    for (let k of Object.keys(this.key)) {
      window.localStorage.removeItem(this.key[k]);
      window.sessionStorage.removeItem(this.key[k]);
    }
  },
  init() {

    // 取得瀏覽器指紋
    //const uid = await concioFingerprint();
    //UTIL.setUID(uid);

    // Key加密
    //CLIENT.storeClientKey = UTIL.encodeByUID(CLIENT.storeClientKey);

    for (let k of Object.keys(this.key)) {
      this.key[k] = CryptoJS.SHA256(this.key[k]).toString();
    }

    //let version = this.getItem(this.key.version);

    // 版號不同重置所有暫存
    //if (!version || version !== Version) {
    //  console.debug("#[LocalData] window.sessionStorage.clear");
    //  window.sessionStorage.clear();
    //}

    //this.setItem(this.key.version, Version);

    //if (STARISE.debug) {
    //  window.sessionStorage.setItem("dev", "Y");
    //}
  },
}

iStoreLocalData.init()

export default iStoreLocalData
